var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('card-header',{attrs:{"title":"Media Library","icon":"fa-photo-film-music"}}),_c('card-body',{staticClass:"is-flex"},[_c('Browser')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }